
export default {
  name: 'NotificationsMap',
  values: {
    BET_REJECTED: 'error',
    EVENT_BETTING_RESTRICTION: 'error',
    EVENT_STARTED: 'error',
    FREE_BET_NOT_APPLICABLE: 'error',
    FREE_BET_WITH_MULTI_LINED_GRP_SGL: 'error',
    FREE_BET_WITH_MORE_THAN_ONE_BET: 'error',
    FREE_BET_WITH_MULTI_LINED_BET: 'error',
    FREE_BET_NOT_MATCH_STAKE: 'error',
    HANDICAP_CHANGE: 'warning',
    MAX_ACC_FOLD_BREACH: 'error',
    MAX_BETSLIP_STAKE_BREACH: 'error',
    MAX_PAYOUT_BREACH: 'error',
    MAX_STAKE_BREACH: 'error',
    MIN_BETSLIP_STAKE_BREACH: 'error',
    MIN_STAKE_BREACH: 'error',
    NOT_AUTHENTICATED: 'error',
    NOT_AUTHORIZED: 'error',
    ODDS_CHANGE: 'warning',
    NO_ODDS_AVAILABLE: 'warning',
    INSUFFICIENT_FUNDS: 'error',
    PRINTER_FAILURE: 'error',
    NOT_COMBINABLE: 'warning',
    RESPONSIBLE_GAMING_GENERIC: 'error',
    RESPONSIBLE_GAMING_STAKING: 'error',
    STAKE_INVALID: 'error',
    STAKING_LIMIT_BREACH: 'error',
    SUSPENDED: 'warning',
    TECHNICAL_FAILURE: 'error',
    UNCOMBINABLE_SELECTION: 'error',
    UNKNOWN: 'error',
    MULTIPLIER_BREACH: 'ignore',
    MANUALLY_REJECTED_BY_TIMEOUT: 'error',
    MANUALLY_REJECTED: 'error',
    REJECTED_BY_TRADER: 'error',
    SELECTION_EXISTS: 'error',
    INVALID_SELECTION: 'warning',
    TEASERS_UNAVAILABLE: 'warning',
    TEASER_MIXED_SPORTS_NOT_ALLOWED: 'warning',
    NOT_ENOUGH_SELECTIONS: 'warning',
    BET_BUILDER_NON_COMBINABLE: 'warning',
    FINISHED_EVENTS_REMOVED: 'warning',
    MIN_COMBINATION_BREACH: 'warning',
    PENDING_TO_LONG: 'error',
    STAKE_BASE_DENOMINATION_BREACH: 'error',
    MIN_DRAW_STAKE_BREACH: 'error',
    MAX_DRAW_STAKE_BREACH: 'error',
    MAX_BETSLIP_WINNING_BREACH: 'error',
    MAX_DRAW_WINNING_BREACH: 'error',
    ODDS_TOKEN_REMOVED: 'warning',
  },
  meta: {
    extendable: true,
  },
}
